<div class="mi-app-progress  container">


    <div class="row justify-content-center mc-mt-18 align-items-center d-sm-none">
        @if (progressValue(); as progressValue) {
        <mc-progress-bar [value]="progressValue" class="col-8" [showValue]="false"></mc-progress-bar>
        <span class=" col-md-1 col-sm-1 col-xs-1 col-1"> {{ currentStep() }}/{{ totalSteps() }}</span>
        }

    </div>

    <div class="row justify-content-center mc-mt-30  d-none d-sm-flex">
        @if(activeTabs(); as activeTabs)
        {
        <div class=" col-10 ">
            <div class="   d-flex flex-column align-items-center">
                <b class="d-xl-none">{{currentTabTitle}}</b>
                <div class="p-step-wrraper">
                    <mc-steps [tabItems]="activeTabs" [activeIndex]="currentTabIndex()"
                        [isReadonly]="true"></mc-steps>
                </div>
            </div>
        </div>
        }
    </div>
</div>
